import React from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, IconsProvider, Button } from '@ab-inbev-maz/compass';
import { useAlertStore } from '../stores/alertStore';
import Header from './Header';
import Sidebar from './Sidebar';
import ModalContainer from './ModalContainer';
import { useSession } from '../features/sso-auth/hooks/useSession';

const AlertContainer = () => {
  const alerts = useAlertStore((state) => state.alerts);
  const removeAlert = useAlertStore((state) => state.removeAlert);

  return (
    <div className="relative w-full">
      {alerts.map((alert) => {

        const handleClose = () => {
          removeAlert(alert.id);
        };

        // Manejar las acciones si existen
        const handleActionClick = (action: { onClick: () => void }) => {
          action.onClick();
          removeAlert(alert.id);
        };

        return (
          <div key={alert.id} className="animate-fade-in shadow-md">
            <Alert
              isClosed={false}
              onClose={handleClose}
              text={alert.text}
              message={alert.message}
              variant={alert.variant || 'simple'}
              status={alert.status}
              close={alert.close !== false}
            >
              {alert.actions?.map((action, index) => (
                <Button
                  key={index}
                  onClick={() => handleActionClick(action)}
                  variant={action.variant || 'secondary'}
                  size={action.size || 'sm'}
                  className="mt-2 mr-2"
                >
                  {action.label}
                </Button>
              ))}
            </Alert>
          </div>
        );
      })}
    </div>
  );
};

const RootLayout: React.FC = () => {
  useSession(); // Initialize session management
  return (
    <IconsProvider>
      <div className="flex flex-col h-screen bg-white">
        <Header />
        <div className="flex-1 flex overflow-hidden">
          <Sidebar />
          <main className="flex-1 overflow-x-hidden overflow-y-auto relative">
            <AlertContainer />
            <ModalContainer />
            <Outlet />
          </main>
        </div>
      </div>
    </IconsProvider>
  );
};

export default RootLayout;